import type {
  MentorshipApplyApiResponse,
  MentorshipProgramDetailApiResponse,
  MentorshipProgramsListApiResponse,
  MentorshipSurveyApiResponse,
} from '@/features/mentorship/types/mentorship-api.types';
import { hrApiClient } from '@/lib/api';

import type {
  MentorshipProgramListQuery,
  MentorshipSurveySubmitInput,
} from '@/shared/job-mentorship';

const PROGRAMS = '/mentorship/programs';

export async function fetchMentorshipProgramsList(
  query?: Partial<MentorshipProgramListQuery>
): Promise<MentorshipProgramsListApiResponse> {
  const { data } = await hrApiClient.get<MentorshipProgramsListApiResponse>(
    PROGRAMS,
    { params: query }
  );
  return data;
}

export async function fetchMentorshipProgramDetail(
  programId: number
): Promise<MentorshipProgramDetailApiResponse> {
  const { data } = await hrApiClient.get<MentorshipProgramDetailApiResponse>(
    `${PROGRAMS}/${programId}`
  );
  return data;
}

export async function postMentorshipApply(
  programId: number
): Promise<MentorshipApplyApiResponse> {
  const { data } = await hrApiClient.post<MentorshipApplyApiResponse>(
    `${PROGRAMS}/${programId}/apply`
  );
  return data;
}

export async function postMentorshipSurvey(
  body: MentorshipSurveySubmitInput
): Promise<MentorshipSurveyApiResponse> {
  const { data } = await hrApiClient.post<MentorshipSurveyApiResponse>(
    '/mentorship/survey',
    body
  );
  return data;
}
